export default __webpack_public_path__ + "static/media/Fiona 9781408300299.9f902390.jpg";